import { useQuery } from "react-query";
import { getRoles } from "../../../admin/user-roles/lib/roleData";

export const useUsersRoles = () => {
    return useQuery({
        // placeholderData: [],
        queryKey: ["userRoles"],
        queryFn: async () => {
            const userRoles = await getRoles();

            return userRoles.items.map(({ id, name }) => {
                return {
                    value: id,
                    displayText: name,
                    text: name,
                };
            });
        },
    });
};
